"use client"

import React, { useRef } from "react"
import { type GameQuery, type MarketOutcome } from "@azuro-org/toolkit"
import cx from "classnames"

import { Icon } from "components/ui"
import OddsValue from "compositions/OddsValue/OddsValue"

import useButton from "./utils/useButton"

type OutcomeButtonProps = {
  marketName: string
  outcome: MarketOutcome
  game: NonNullable<GameQuery["game"]>
  isLocked: boolean
  size?: 28 | 40
  section?: string
}

const OutcomeButton: React.FC<OutcomeButtonProps> = props => {
  const { marketName, outcome, game, isLocked, size = 28, section } = props
  const { selectionName } = outcome

  const nodeRef = useRef<HTMLDivElement>(null)
  const { odds, isActive, onClick } = useButton({
    outcome,
    nodeRef,
    game,
    marketName,
    section,
  })

  const buttonClassName = cx(
    "group/button w-full relative flex items-center justify-between ds:px-3 mb:px-2 overflow-hidden",
    "text-caption-13 font-medium border-none rounded-min select-none",
    {
      "hover:text-brand-light-500 hover:bg-brand-900": !isLocked && !isActive,
      "text-black bg-brand-light-200": isActive,
      "bg-accent-grey-800": !isActive,
      "text-accent-grey-200 cursor-not-allowed": isLocked,
      "h-7": size === 28,
      "h-10": size === 40,
    }
  )
  const titleClassName = cx("text-left truncate min-w-0", {
    "group-hover/button:text-brand-light-500": !isLocked && !isActive,
    "text-black": isActive,
    "text-accent-grey-200": !isActive || isLocked,
  })
  const oddsClassName = cx("group/odds flex items-center")
  const arrowClassName = cx(
    "size-4 text-transparent transition-color",
    "group-[.increased]/odds:text-accent-green-700",
    "group-[.decreased]/odds:text-accent-red-700 group-[.decreased]/odds:rotate-180"
  )
  const valueClassName = cx(
    "transition-color",
    "group-[.increased]/odds:text-accent-green-700",
    "group-[.decreased]/odds:text-accent-red-700"
  )

  return (
    <button className={buttonClassName} disabled={isLocked} onClick={onClick}>
      <div className="flex items-center flex-1 min-w-0 ">
        {isLocked && (
          <Icon
            className="mr-1 size-4 text-accent-grey-400 flex-shrink-0"
            name="interface/lock"
          />
        )}
        {/* <div className={titleClassName}>ajskjas akshkjas jasnxkja</div> */}
        <div className={titleClassName}>{selectionName}</div>
      </div>
      <div ref={nodeRef} className={oddsClassName}>
        <Icon className={arrowClassName} name="interface/caret_up" />
        <OddsValue className={valueClassName} odds={odds} />
      </div>
    </button>
  )
}

export default OutcomeButton
